export const ADDRESS_FETCH_INIT = 'ADDRESS_FETCH_INIT';
export const ADDRESS_FETCH_SUCCESS = 'ADDRESS_FETCH_SUCCESS';
export const ADDRESS_FETCH_ERROR = 'ADDRESS_FETCH_ERROR';

export const ADDRESS_POST_INIT = 'ADDRESS_POST_INIT';
export const ADDRESS_POST_SUCCESS = 'ADDRESS_POST_SUCCESS';
export const ADDRESS_POST_ERROR = 'ADDRESS_POST_ERROR';

export const ADDRESS_RESET = 'ADDRESS_RESET';
